export default __webpack_public_path__ + "static/media/renewal-available_loan.a1f91275.jpg";